import convert from "xml-js"

const NAME_ATTR = /\bname\s*=\s*"([^"]+)"/

const tagNames = (xml, localName) => {
    const re = new RegExp(`<(?:[\\w.-]+:)?${localName}\\b([^>]*)>`, "g")
    const names = []
    let match
    while ((match = re.exec(xml))) {
        const name = match[1].match(NAME_ATTR)?.[1]
        if (name) names.push(name)
    }
    return [...new Set(names)]
}

export function summarizeXsd(xml) {
    const raw = String(xml ?? "")
    return {
        targetNamespace: raw.match(/\btargetNamespace\s*=\s*"([^"]*)"/)?.[1] || "",
        elements: tagNames(raw, "element"),
        complexTypes: tagNames(raw, "complexType"),
        simpleTypes: tagNames(raw, "simpleType"),
    }
}

export function summarizeWsdl(xml) {
    const raw = String(xml ?? "")
    const defs = raw.match(/<(?:[\w.-]+:)?definitions\b([^>]*)>/)
    const attrs = defs?.[1] || ""
    return {
        ...summarizeXsd(raw),
        name: attrs.match(NAME_ATTR)?.[1] || "",
        targetNamespace: attrs.match(/\btargetNamespace\s*=\s*"([^"]*)"/)?.[1]
            || raw.match(/\btargetNamespace\s*=\s*"([^"]*)"/)?.[1]
            || "",
        services: tagNames(raw, "service"),
        ports: tagNames(raw, "port"),
        portTypes: tagNames(raw, "portType"),
        operations: tagNames(raw, "operation"),
        messages: tagNames(raw, "message"),
        bindings: tagNames(raw, "binding"),
    }
}

export function xmlToJson(xml) {
    try {
        return convert.xml2js(String(xml ?? ""), {
            compact: true,
            ignoreComment: true,
        })
    } catch {
        return null
    }
}

export function xmlToPrettyJson(xml) {
    try {
        return convert.xml2json(String(xml ?? ""), {
            compact: true,
            ignoreComment: true,
            spaces: 2,
        })
    } catch {
        return ""
    }
}

export function prettyXml(xml) {
    const raw = String(xml ?? "")
    if (!raw.trim()) return ""
    if (/\n[ \t]+</.test(raw)) return raw

    const tokens = raw.match(/<!--[\s\S]*?-->|<!\[CDATA\[[\s\S]*?\]\]>|<\?[\s\S]*?\?>|<\/?[^>]+>|[^<]+/g) || []
    let indent = 0
    const lines = []
    for (const token of tokens) {
        const text = token.trim()
        if (!text) continue
        if (text.startsWith("</")) {
            indent = Math.max(0, indent - 1)
            lines.push(`${"  ".repeat(indent)}${text}`)
            continue
        }
        if (text.startsWith("<") && !text.startsWith("<?") && !text.startsWith("<!") && !text.endsWith("/>")) {
            lines.push(`${"  ".repeat(indent)}${text}`)
            indent += 1
            continue
        }
        lines.push(`${"  ".repeat(indent)}${text}`)
    }
    return `${lines.join("\n")}\n`
}
